// extracted by mini-css-extract-plugin
export default {"section":"Login_section__0InfM","forgotPassword":"Login_forgotPassword__a5gQA"};